import React from 'react'
import PropTypes from 'prop-types'

const VariableItem = ({ children, name, onRemove }) => (
  <div className="bg-light py-3 px-3 mb-3 d-flex align-items-center">
    <div className="flex-grow-1">
      <p className="font-weight-bolder text-dark mb-2">
        Variable :
        {' '}
        {name}
      </p>
      {children}
    </div>
    <button
      type="button"
      className="btn btn-link p-0 ml-3 text-dark hover-danger"
      onClick={onRemove}
    >
      <i className="fas fa-trash" />
    </button>
  </div>
)

VariableItem.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired
}

export default VariableItem
